export default {
  search: {
    title: "Recherche",
    trending: "Tendances",
    noResults: 'Aucun résultat trouvé pour "{{query}}"',
    sections: {
      games: "Matchs",
      props: "Props",
      position: "Position",
      trending: "Tendances",
      players: "Joueurs",
      teams: "Équipes",
      markets: "Marchés",
      matchups: "Affrontements",
    },
    empty: {
      noResults: 'Aucun résultat trouvé pour "{{query}}"',
      noGamesAvailable: "Aucun match disponible",
      checkBackLater: "Veuillez revenir plus tard",
    },
    actions: {
      searchByGame: "Rechercher par match",
      viewMatchups: "Voir les affrontements",
      searchByProp: "Rechercher par prop",
      searchByPosition: "Rechercher par position",
    },
    discovery: {
      Hits: "Coups sûrs",
      "Total Bases": "Total de buts",
      RBI: "Points produits",
      Strikeouts: "Retraits sur prises",
      Results: "Résultats",
      Totals: "Totaux",
      "Goals & Assists": "Buts et aides",
      "Shots on Goal": "Tirs au but",
      Points: "Points",
      "Powerplay Points": "Points en avantage numérique",
    },
    positions: {
      Forwards: "Attaquants",
      Midfielders: "Milieux",
      Defense: "Défense",
      Guards: "Arrières",
      Centers: "Pivots",
      QB: "QB",
      RB: "RB",
      WR: "WR",
      TE: "TE",
      K: "K",
      Wingers: "Ailiers",
      Goalies: "Gardiens",
      Pitchers: "Lanceurs",
      Hitters: "Frappeurs",
    },
  },
};
